import { Observable } from "rxjs";
import HttpService from "./HttpService";
import AuthService from "./AuthService";
import { url } from "./APIEndPoints";
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import {
  IAPIFindAccountResponseModel,
  IAPIGeneralSettingsModel,
} from "../interfaces/PaymentSettingsInterfaces";
import { IAPIApplicationSettingsModel } from "../interfaces";

class AccountService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getGeneralSettings(): Observable<IAPIResponse<IAPIGeneralSettingsModel>> {
    const params: string = buildParamString({
      accountId: AuthService.authData.accountId,
    });
    return this.httpService.get<IAPIResponse<IAPIGeneralSettingsModel>>(
      url.getGeneralSettings,
      params
    );
  }

  updateGeneralSettings(
    data: IAPIGeneralSettingsModel
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.put<IAPIResponse<boolean>>(
      url.updateGeneralSettings,
      data
    );
  }

  findAccount(
    subAccountId: string,
    parentAccountId: string
  ): Observable<IAPIResponse<IAPIFindAccountResponseModel>> {
    const params: string = buildParamString({
      subAccountId: subAccountId,
      parentAccountId: parentAccountId,
    });
    return this.httpService.get<IAPIResponse<IAPIFindAccountResponseModel>>(
      url.findAccount,
      params
    );
  }

  getApplicationSettings(): Observable<
    IAPIResponse<IAPIApplicationSettingsModel>
  > {
    return this.httpService.get<IAPIResponse<IAPIApplicationSettingsModel>>(
      url.getApplicationSettings,
      undefined
    );
  } 
}
export default new AccountService();
